<!-- @format -->

<template>
	<div
		:style="{
			height: height,
		}"
		class="pcp_uplpad"
	>
		<div class="pcp_uploader">
			<el-upload
				ref="uploadRef"
				:file-list="fileList"
				:show-file-list="false"
				:on-remove="handleRemove"
				:on-success="handleSuccess"
				:on-error="handleError"
				:before-upload="beforeUpload"
				:http-request="httpRequest"
				:multiple="multiple"
				:accept="accept"
				:action="fileUploadAction"
				name="file"
				drag
				list-type="picture-card"
			>
				<el-icon><Plus /></el-icon>
				<div>
					<span v-if="(multiple && fileList.length === 0) || !multiple">点击上传图片</span>
					<span v-else>继续上传</span>
				</div>
			</el-upload>

			<el-dialog v-model="dialogVisible">
				<img :src="dialogImageUrl" width="100%" alt="" />
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import { isString } from '@power/utils';
	import { fileTypes, allFileTypes, accept as acceptTypes } from './constants/fileTypes';
	import { uploadFile, remove } from '@/api/global/index';
	import { $utils } from '@/utils/publicUtils';
	export default {
		props: {
			height: String,
			init: Boolean,
			isUploadImage: Boolean, //是否允许上传图片
			limit: Number, // 限制个数
			multiple: Boolean,
			fileSize: Number, // 尺寸
			accept: String, // 类型
			fullscreen: {
				type: Boolean,
				default: false,
			},
			folderAlias: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				fileUploadAction: 'https://www.bpmhome.cn/post',
				uploadData: {}, // 可以添加分类、文件等信息
				fileList: [],
				dialogVisible: false,
				targetExt: false,
				dialogImageUrl: '',
				fileTypes,
				allFileTypes,
				acceptTypes,
			};
		},
		watch: {
			init: {
				handler() {
					if (this.init) {
						this.fileList = [];
					}
				},
				immediate: true,
			},
		},
		beforeUnmount() {
			this.uploadData = null;
			this.fileList = null;
			this.fileTypes = null;
			this.allFileTypes = null;
			this.acceptTypes = null;
		},
		methods: {
			/**
			 * 文件上传
			 */
			httpRequest(options) {
				return uploadFile(options.file, this.folderAlias, {});
			},
			// 做文件校验
			beforeUpload(file) {
				if ($utils.isNotEmpty(this.limit) && this.limit === 0) {
					this.$message.closeAll();
					this.$message({
						message: `上传文件个数不能为0，请重新设置`,
						type: 'warning',
					});
					return false;
				}
				if ($utils.isNotEmpty(this.fileSize) && file.size > this.fileSize) {
					this.$message.closeAll();
					this.$message({
						message: `上传文件的尺寸大于${$utils.formatSize(this.fileSize, 2, ['B', 'KB', 'MB', 'GB', 'TB'])}`,
						type: 'warning',
					});
					return false;
				}
				// if (this.$utils.isNotEmpty(this.accept) && this.handleAccpt(file) || this.fileExtType(file)) {
				if ($utils.isNotEmpty(this.accept) && this.accept && !this.fileExtType(file)) {
					this.$message.closeAll();
					this.$message({
						message: '不允许的文件类型',
						type: 'warning',
					});
					return false;
				}

				// if (!this.multiple && this.$utils.isNotEmpty(this.fileList)) {
				// 	this.$message.closeAll();
				// 	this.$message({
				// 		message: '附件上传设置为单选，文件上传只能为1个',
				// 		type: 'warning',
				// 	});
				// 	return false;
				// }
			},
			LOWER(a) {
				return isString(a) ? (a ? a.toLowerCase() : a) : '';
			},
			/**
			 * 文件类型的检测
			 */
			fileExtType(file) {
				const accept = this.accept;
				const acceptTypes = this.acceptTypes;
				const fileTypes = this.fileTypes;
				const arr = file.name.split('.');
				const result = arr[arr.length - 1];
				let type = '';
				this.targetExt = false;
				for (const i in acceptTypes) {
					if (acceptTypes[i] === accept) {
						type = i;
					}
				}
				if (type !== '' && this.accept !== '*') {
					// 现存的附件类型
					const fileAccept = this.LOWER(result); // 统一处理文件大小写
					const targetFileTypes = fileTypes[type];
					this.targetExt = targetFileTypes.includes(fileAccept);
				} else {
					if (this.accept === '*') {
						// 不限制
						this.targetExt = true;
					} else {
						// 自定义
						const targetFileTypes = this.accept.split(',');
						this.targetExt = targetFileTypes.includes(`.${result}`);
					}
				}
				return this.targetExt;
			},
			/**
			 * 文件类型的限制
			 */
			// handleAccpt(file) {
			//   const rExt = /\.\w+$/
			//   let accept = ''
			//   const arr = []
			//   const extensions = this.accept.split(',')

			//   const acceptTypes = this.acceptTypes
			//   const acceptArr = []
			//   for (var i in acceptTypes) {
			//     acceptArr.push(acceptTypes[i])
			//   }
			//   const inAcceptTypes = acceptArr.includes(this.accept)

			//   for (let i = 0, len = extensions.length; i < len; i++) {
			//     const item = extensions[i]
			//     if (item) {
			//       if (item.indexOf('/')) {
			//         const v = item.split('/')
			//         let k = item
			//         if (v.length > 0) {
			//           k = v[v.length - 1]
			//         }
			//         arr.push(k)
			//       } else {
			//         arr.push(item)
			//       }
			//     }
			//   }
			//   if (arr.length) {
			//     accept = '\\.' + arr.join(',')
			//       .replace(/,/g, '$|\\.')
			//       .replace(/\*/g, '.*') + '$'
			//   }
			//   accept = new RegExp(accept, 'i')
			//   return !file || !file.size || this.accept &&
			//   // 如果名字中有后缀，才做后缀白名单处理。
			//      rExt.exec(file.name) && !accept.test(file.name) && inAcceptTypes
			// },
			handleSuccess(response, file, fileList) {
				console.log(response);
				let ext = this.getExtName(file.name);
				let url = '';
				if ($utils.isEmpty(ext)) {
					ext = 'file';
				}
				if (['jpg', 'jpeg', 'bmp', 'png'].includes(ext)) {
					url = file.url;
				} else {
					url = `${this.$baseUrl}images/file/${ext}.png`;
				}
				file.url = url;

				this.fileList = fileList;
				this.emitCallback(fileList);
			},
			// 获取扩展名
			getExtName(name) {
				return name ? name.substring(name.lastIndexOf('.') + 1, name.length) : '';
			},
			handleError(err, file, fileList) {
				console.log(file, 111);
				this.fileList = fileList;
				if (!(err instanceof Error)) {
					const data = $utils.parseJSON(err.message);
					this.$message.closeAll();
					this.$message({
						message: $utils.isNotEmpty(data.message) ? data.message : data.cause,
						type: 'error',
					});
				}
			},
			handleRemove(file, fileList) {
				this.fileList = fileList;
				if (file && file.response) {
					this.handleRemoteRemove(file.response.id, () => {
						this.emitCallback(fileList);
					});
				}
			},
			emitCallback(fileList) {
				this.$emit('callback', this.convertFileDataList(fileList, this.multiple));
			},
			convertFileDataList(fileList, multiple) {
				if ($utils.isEmpty(fileList)) {
					return multiple ? [] : {};
				}
				const rtn = [];
				fileList.forEach((file) => {
					if ($utils.isNotEmpty(file.response)) {
						rtn.push(file.response);
					}
				});
				return multiple ? rtn : rtn[rtn.length - 1];
			},
			/**
			 * 清空
			 */
			clearFiles() {
				const ids = this.fileList
					.map((file) => {
						return file.response.id;
					})
					.join(',');
				this.fileList = [];
				if ($utils.isEmpty(ids)) {
					this.$message.warning('请先上传文件！');
					return;
				}
				this.handleRemoteRemove(ids, () => {
					this.$refs.uploadRef.clearFiles();
					this.$emit('callback', this.multiple ? [] : (this.fileList = []));
				});
			},
			handleRemoteRemove(ids, callback) {
				remove({ id: ids })
					.then(() => {
						callback(this);
					})
					.catch(() => {});
			},
			handlePreview() {
				this.dialogVisible = true;
			},
		},
	};
</script>
<style lang="scss">
	// .ibps-uplpad {
	// 	overflow-y: auto;

	// 	.header {
	// 		height: 45px;
	// 		border-bottom: 1px solid #dadada;
	// 		margin: 0;
	// 		padding: 0;
	// 		line-height: 45px;
	// 		vertical-align: middle;
	// 		position: relative;
	// 	}

	// 	.btns {
	// 		position: absolute;
	// 		top: 7px;
	// 		right: 0;
	// 		line-height: 30px;
	// 	}

	// 	.uploader {
	// 		list-style: none;
	// 		margin: 0;
	// 		padding-top: 5px;
	// 	}

	.pcp_uploader .el-upload--picture-card {
		border: 0;
		background: #fff;
	}

	.el-upload-dragger {
		height: 100%;
	}

	// 	.el-upload-list--picture-card .el-upload-list__item-name {
	// 		display: block;
	// 		position: absolute;
	// 		top: 0px;
	// 		background: rgba(0, 0, 0, 0.6);
	// 		color: white;
	// 		margin: 0;
	// 		width: 100%;
	// 	}

	// 	.el-upload-dragger .el-icon--upload {
	// 		margin-bottom: 20px;
	// 	}
	// }
</style>
<style scoped>
	:deep(.el-upload-dragger) {
		border-radius: 1px;
	}
</style>
